import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Lock, Star, Target } from 'lucide-react';

interface TaskLimitNudgeProps {
  onCreateAccount: () => void;
  onClose: () => void;
}

const TaskLimitNudge: React.FC<TaskLimitNudgeProps> = ({ onCreateAccount, onClose }) => {
  return (
    <Card className="max-w-md mx-auto bg-gradient-to-br from-primary/10 to-primary/5 border-primary/20">
      <CardHeader className="text-center pb-3">
        <div className="w-12 h-12 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-3">
          <Lock className="w-6 h-6 text-primary" />
        </div>
        <CardTitle className="text-xl">Ready for more tasks?</CardTitle>
      </CardHeader>
      <CardContent className="text-center space-y-4">
        <p className="text-muted-foreground">
          You've created your first task! Create a free account to unlock unlimited tasks and powerful features.
        </p>
        
        <div className="bg-background/50 rounded-lg p-3 space-y-2">
          <div className="flex items-center gap-2 text-sm">
            <Star className="w-4 h-4 text-primary" />
            <span>Unlimited tasks & lists</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Target className="w-4 h-4 text-primary" />
            <span>Progress tracking & analytics</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Lock className="w-4 h-4 text-primary" />
            <span>Sync across all devices</span>
          </div>
        </div>

        <div className="space-y-2 pt-2">
          <Button onClick={onCreateAccount} className="w-full">
            Create free account
          </Button>
          <Button variant="ghost" onClick={onClose} className="w-full text-sm">
            Maybe later
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default TaskLimitNudge;